<template>
  <div class="page-wrapper">
    <div class="container">
      <div class="row nav-container">
        <ul>
          <li><a href="#/admin/home/">메인</a></li>
          <li><a href="#/admin/checkin/">체크인</a></li>
          <li><a href="#/admin/settings/">세팅</a></li>
          <li><a href="#/admin/customers/">업체</a></li>
          <li><a href="#/admin/forwarders/">파트너</a></li>
          <li><a class="active" href="#/admin/users/">사용자</a></li>
          <li>
            <div class="logout" v-on:click="logout">로그아웃</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-6">
          <div class="card">
            <div class="card-header">
              내계정
            </div>
            <div class="card-body">
              <div class="container">
                <div class="form-group row section-container">
                  <div class="col-6">아이디</div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="user.user_name" disabled/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6">이메일</div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="user.email" v-on:keyup="checkIfUpdatable"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6">레벨</div>
                  <div class="col-6">
                    <select class="form-control" v-model="user.level" disabled>
                      <option value="0">직원</option>
                      <option value="5">메니저</option>
                      <option value="10">관리자</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6">비밀번호</div>
                  <div class="col-6">
                    <input type="password" class="form-control" v-model="user.password" v-on:keyup="checkIfUpdatable"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6">비밀번호 확인</div>
                  <div class="col-6">
                    <input type="password" class="form-control" v-model="user.passwordConfirm"
                           v-on:keyup="checkIfUpdatable"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6"></div>
                  <div class="col-6">
                    <button type="button" class="btn btn-primary" v-show="canUpdate == true"
                            v-on:click="updateMyAccount()">업데이트
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container section-container" if="users.length > 0">
      <h4>User List
        <div v-show="newUser == false" class="btn btn-primary" v-on:click="openNewUserForm()">Add</div>
      </h4>
      <table class="table">
        <tr>
          <th>User Name</th>
          <th>Email</th>
          <th>Level</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in users">
          <td>{{item.user_name}}</td>
          <td>{{item.email}}</td>
          <td>{{getLevelString(item.level)}}</td>
          <td>
            <button v-show="newUser == false" type="button" class="btn btn-primary" v-on:click="editUser(index)">Edit
            </button>
          </td>

        </tr>
      </table>
    </div>
    <div class="new-item-form" v-if="newUser != false">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h4 v-if="newUser.id == 0">계정등록</h4>
            <h4 v-if="newUser.id > 0">계정수정</h4>
          </div>
        </div>
        <div class="form-group row section-container">
          <div class="col-6">아이디</div>
          <div class="col-6">
            <input type="text" class="form-control" v-model="newUser.user_name" :disabled="newUser.id>0"/>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-6">이메일</div>
          <div class="col-6">
            <input type="text" class="form-control" v-model="newUser.email"/>
          </div>
        </div>
        <div class="form-group row" v-if="(newUser.id == 0 || newUser.id == user.id)">
          <div class="col-6">비밀번호</div>
          <div class="col-6">
            <input type="password" class="form-control" v-model="newUser.password"/>
          </div>
        </div>
        <div class="form-group row" v-if="(newUser.id == 0 || newUser.id == user.id)">
          <div class="col-6">비밀번호 확인</div>
          <div class="col-6">
            <input type="password" class="form-control" v-model="newUser.passwordConfirm"/>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-6">레벨</div>
          <div class="col-6">
            <select class="form-control" v-model="newUser.level">
              <option value="0">직원</option>
              <option value="5">메니저</option>
              <option value="10">관리자</option>
            </select>
          </div>
        </div>
      </div>
      <div class="container section-container">
        <div class="row">
          <div class="col-6">
            <button type="button" class="btn btn-secondary" v-on:click="closeNewUserForm()">닫기</button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-primary" v-on:click="submitNewUserForm()">
              <span v-if="newUser.id==0">생성</span>
              <span v-if="newUser.id>0">업데이</span>
            </button>

          </div>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>
<script>
    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';

    export default {
        name: 'CustomerManagement',

        data() {
            return {
                msg: 'Users',
                user: false,
                origUser: false,
                users: [],
                newUser: false,
                canUpdate: false,

            }
        },
        created: function () {
            if (localStorage.getItem('id') == undefined || localStorage.getItem('id') == null || localStorage.getItem('id') === '') {
                Router.push('/admin');
                return;
            }
            this.$data.user = {
                "id": localStorage.getItem('id'),
                "level": localStorage.getItem('level'),
                "password": '',
                "passwordConfirm": '',
            }

            console.log("User");
            console.log(this.$data.user);
            this.getUserList();
            registerBackKeyHandler(this.backHandler);


        },
        mounted: function () {

        },
        methods: {
            logout: function () {
                var self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem('id');
                localStorage.removeItem('email');
                localStorage.removeItem('level');
                localStorage.removeItem('admin');
                localStorage.removeItem('password');
                Router.push('/admin');
            },
            backHandler: function () {
                console.log("Main back pressed");
                if (this.$data.newUser != false) {
                    this.$data.newUser = false;
                    return;
                }

            },
            getLevelString: function (level) {
                if (level == 0) {
                    return '직원';
                } else if (level == 5) {
                    return '메니저';
                } else if (level == 10) {
                    return '관리자';
                }
                return 'Unknown';
            },
            getUserList: function () {
                var self = this;
                var url = process.env.APP_URL + 'api/get_users.php?id=' + this.$data.user.id + '&level=' + this.$data.user.level;
                axios.get(url)
                    .then(response => {
                        console.log("Get Users");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            for (var i = 0; i < data.list.length; i++) {
                                if (self.$data.user.id == data.list[i].id) {
                                    self.$data.user = data.list[i];
                                    self.$data.user["password"] = '';
                                    self.$data.user["passwordConfirm"] = "";
                                    self.$data.origUser = {
                                        email: data.list[i].email,

                                    };
                                } else {
                                    self.$data.users.push(data.list[i]);
                                }
                            }

                        } else {
                            self.$modal.show('dialog', {
                                title: 'ERROR',
                                text: data.message,
                            });
                        }
                    })
                    .catch(error => {

                    });
            },
            editUser: function (index) {
                this.$data.newUser = {
                    id: this.$data.users[index].id,
                    user_name: this.$data.users[index].user_name,
                    password: '',
                    passwordConfirm: '',
                    email: this.$data.users[index].email,
                    level: this.$data.users[index].level,
                };
            },
            openNewUserForm: function () {
                this.$data.newUser = {
                    id: 0,
                    user_name: '',
                    password: '',
                    passwordConfirm: '',
                    email: '',
                    level: 0
                };
            },
            closeNewUserForm: function () {
                this.$data.newUser = false;
            },
            showModal: function (title, message) {
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                });
            },
            checkIfUpdatable: function () {
                if (this.$data.user.email != this.$data.origUser.email) {
                    this.$data.canUpdate = true;
                    return;
                }

                if (this.$data.user.password.length > 0) {
                    this.$data.canUpdate = true;
                    return;
                }
                this.$data.canUpdate = false;
            },
            updateMyAccount: function () {
                var data = {};
                var toUpdate = false;
                if (this.$data.user.email != this.$data.origUser.email) {
                    data["email"] = this.$data.user.email;
                    toUpdate = true;
                }

                if (this.$data.user.password.length > 0) {
                    if (this.$data.user.password != this.$data.user.passwordConfirm) {
                        this.showModal("ERROR", "비밀번호가 일치하지 않습니다");
                        return;
                    }
                    data["password"] = this.$data.user.password;
                    toUpdate = true;
                }

                if (toUpdate == false) {
                    console.log("Nothing to update");
                    return;
                }
                data["id"] = this.$data.user.id;
                var postData = {
                    "table": "user_table",
                    "data": data,
                };
                var self = this;
                var url = process.env.APP_URL + 'api/update.php';
                axios.post(url, postData)
                    .then(response => {
                        console.log("Get Users");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.user.email = data.item.email;

                            self.$modal.show('dialog', {
                                title: 'UPDATE',
                                text: 'Successfully Updated',
                            });

                        } else {
                            self.$modal.show('dialog', {
                                title: 'ERROR',
                                text: data.message,
                            });
                        }
                        self.$data.user.password = '';
                        self.$data.user.passwordConfirm = '';
                    })
                    .catch(error => {
                        self.$modal.show('dialog', {
                            title: 'ERROR',
                            text: error,
                        });
                        self.$data.password = '';
                        self.$data.passwordConfirm = '';
                    });

            },
            submitNewUserForm: function () {
                if (this.$data.newUser.id == 0 && this.$data.newUser.user_name.length < 4) {
                    this.showModal("ERROR", "아이디는 4글자 이상이여야 합니다");
                    return;
                }

                if (this.$data.newUser.id == 0 && this.$data.newUser.password.length < 4) {
                    this.showModal("ERROR", "비밀번호는 4글자 이상이여야 합니다");
                    return;

                }
                if (this.$data.newUser.id == 0 && this.$data.newUser.password != this.$data.newUser.passwordConfirm) {
                    this.showModal("ERROR", "비밀번호가 일치하지 않습니다");
                    return;

                }
                if (this.$data.newUser.email.length < 4) {
                    this.showModal("ERRO", "이메일을 입력해주세요");
                    return;
                }

                var self = this;
                if (this.$data.newUser.id == 0) {
                    var data = {
                        user_name: this.$data.newUser.user_name,
                        password: this.$data.newUser.password,
                        level: this.$data.newUser.level,
                        email: this.$data.newUser.email,
                    };

                    var url = process.env.APP_URL + 'api/create_user.php';
                    axios.post(url, data)
                        .then(response => {
                            console.log("Get Users");
                            console.log(response);

                            var data = response.data;
                            if (data.success == true) {
                                self.$data.users.push(data.item);

                            } else {
                                self.$modal.show('dialog', {
                                    title: 'ERROR',
                                    text: data.message,
                                });
                            }
                        })
                        .catch(error => {
                            self.$modal.show('dialog', {
                                title: 'ERROR',
                                text: error,
                            });
                        });
                } else {
                    var data = {
                        id: this.$data.newUser.id,
                        level: this.$data.newUser.level,
                        email: this.$data.newUser.email,
                    };
                    var postData = {
                        "table": "user_table",
                        "data": data,
                    };
                    var url = process.env.APP_URL + 'api/update.php';
                    axios.post(url, postData)
                        .then(response => {
                            console.log("Get Users");
                            console.log(response);

                            var data = response.data;
                            if (data.success == true) {
                                var updatedItem = data.item;
                                for (var i = 0; i < self.$data.users.length; i++) {
                                    if (updatedItem.id == self.$data.users[i].id) {
                                        self.$data.users[i].level = updatedItem.level;
                                        self.$data.users[i].email = updatedItem.email;
                                    }
                                }

                            } else {
                                self.$modal.show('dialog', {
                                    title: 'ERROR',
                                    text: data.message,
                                });
                            }
                            self.$data.newUser = false;
                        })
                        .catch(error => {
                            self.$modal.show('dialog', {
                                title: 'ERROR',
                                text: error,
                            });
                            self.$data.newUser = false;
                        });

                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/AdminUser.vue